import { render } from "./IndustrialBankTab.vue?vue&type=template&id=71ce7c12&scoped=true"
import script from "./IndustrialBankTab.vue?vue&type=script&lang=ts"
export * from "./IndustrialBankTab.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-71ce7c12"

export default script